import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getGiftGivingReport (id) {
        return httpService.get(ApiEndpoints.get('gift_giving_report_data', { familyEditionId: id }));
    },
    createGiftGivingReportDraft (data) {
        return httpService.post(
            ApiEndpoints.get('gift_giving_report_draft', { familyEditionId: data.id }),
            { gift_giving_report_draft_json: data.gift_giving_report_draft_json }
        );
    },
    getGiftGivingReportDraft (id) {
        return httpService.get(ApiEndpoints.get('gift_giving_report_draft', { familyEditionId: id }));
    },
    removeGiftGivingReportDraft (id) {
        return httpService.delete(ApiEndpoints.get('gift_giving_report_draft', { familyEditionId: id }));
    },
    preCreateGivingReport (id) {
        return httpService.post(
            ApiEndpoints.get('pre_create_gift_giving_report', { familyEditionId: id })
        );
    }
};
